// extracted by mini-css-extract-plugin
export default {"badge":"BadgeAwaitingReview_badge__pzcc7"};